// Velo API Reference: https://www.wix.com/velo/reference/api-overview/introduction

import wixLocation from 'wix-location';
import wixLocationFrontend from "wix-location-frontend";



$w.onReady(function () {
	// ---------------------------------------------------------------------------
	// Ok, this takes the 404 error, checks if it's a search query then passes it to ecom site as a search
	//  it can handle single and double search terms
	// https://www.campbells.com.au/convenience/search?text=coke
	// https://www.campbells.com.au/convenience/search?text=coke+cola
	// https://www.campbells.com.au/convenience/?q=Corn+flour
	let url = wixLocationFrontend.url;



	// Hash of all the ad hoc redirects we want to use
	const redirect_urls = new Map();
	redirect_urls.set("https://www.campbells.com.au/catalogue", "https://campbells.sorted.au/catalogue");
	redirect_urls.set("https://www.campbells.com.au/catalogue?", "https://campbells.sorted.au/catalogue");

	redirect_urls.set("https://www.campbells.com.au/convenience", "https://campbells.sorted.au");
	redirect_urls.set("https://www.campbells.com.au/convenience/", "https://campbells.sorted.au");
	redirect_urls.set("https://www.campbells.com.au/convenience/register", "https://campbells.sorted.au/login/register");
	redirect_urls.set("https://www.campbells.com.au/convenience/catalogue", "https://campbells.sorted.au/catalogue");
	redirect_urls.set("https://campbells.com.au/convenience/catalogue", "https://campbells.sorted.au/catalogue");

	

	redirect_urls.set("https://www.campbells.com.au/convenience/my-account/reports/invoices", "https://campbells.sorted.au");
	redirect_urls.set("https://www.campbells.com.au/convenience", "https://campbells.sorted.au");
	redirect_urls.set("https://www.campbells.com.au/convenience/#", "https://campbells.sorted.au");
	redirect_urls.set("https://www.campbells.com.au/convenience/frozen-food/party-food", "https://campbells.sorted.au/Open-Catalogue/FROZEN/PARTY-ENTERTAINING/c/347");
	redirect_urls.set("https://www.campbells.com.au/convenience/faq", "https://https://www.campbells.com.au/faqs");
	redirect_urls.set("https://www.campbells.com.au/convenience/search/?", "https://https://www.campbells.com.au");
	redirect_urls.set("https://www.campbells.com.au/convenience/search", "https://https://www.campbells.com.au");
	redirect_urls.set("https://www.campbells.com.au/convenience/my-account/reports/invoices", "https://campbells.sorted.au");
	redirect_urls.set("https://www.campbells.com.au/convenience/alcohol/accessories/bar-accessories", "https://campbells.sorted.au/open-catalogue/c/19");
	redirect_urls.set("https://www.campbells.com.au/convenience//orderForm", "https://campbells.sorted.au");
	redirect_urls.set("https://www.campbells.com.au/convenience/my-account/reports/invoices", "https://campbells.sorted.au");
	redirect_urls.set("https://www.campbells.com.au/convenience/login/continue", "https://campbells.sorted.au/login");
	redirect_urls.set("https://www.campbells.com.au/convenience/my-account/order/ext06582871", "https://campbells.sorted.au/login");
	redirect_urls.set("https://www.campbells.com.au/convenience/tradinglp", "https://campbells.sorted.au/login");
	redirect_urls.set("https://www.campbells.com.au/convenience/contact-us", "https://campbells.sorted.au/contact-us");
 	redirect_urls.set("https://www.campbells.com.au/convenience/cart", "https://campbells.sorted.au/cart");
  	redirect_urls.set("https://www.campbells.com.au/convenience/aboutus", "https://www.campbells.com.au");
	redirect_urls.set("https://www.campbells.com.au/convenience/orderForm", "https://campbells.sorted.au/order-form");
	redirect_urls.set("https://www.campbells.com.au/convenience/cart#", "https://campbells.sorted.au/cart");
	redirect_urls.set("https://www.campbells.com.au/convenience/foodservice---bulk-buy", "https://campbells.sorted.au/");
	redirect_urls.set("https://www.campbells.com.au/convenience/catalogue#catalogueList", "https://campbells.sorted.au/catalogue");



	//redirect_urls.set("", "");
	//redirect_urls.set("", "");
	//redirect_urls.set("", "");
	//redirect_urls.set("", "");
	//redirect_urls.set("", "");
	//redirect_urls.set("", "");
		//redirect_urls.set("", "");
	//redirect_urls.set("", "");
	//redirect_urls.set("", "");
	//redirect_urls.set("", "");
	//redirect_urls.set("", "");



	let goTo;

	// Gets the value if it's an exact match otherwise return 'undefined'
	goTo = redirect_urls.get(url);

	// ---------------------------------------------------------------------------
	// Ok, this takes the 404 error, checks if it's a search query then passes it to ecom site as a search

	// https://www.campbells.com.au/convenience/?q=Corn+flour+
	// Match this URL
	// https://www.campbells.com.au/convenience/search?text=coke
	var re = new RegExp(/search\?text|\?q/);

	var re3 = new RegExp(/_890|_849/);
	var re4 = new RegExp(/store\-finder/);




	if (re4.test(url)) {
	// Match on 'store-finder'

		// Log the original url which got redirected
		console.log("REDIRECT 404 error: https://campbells.sorted.au/store-finder");		

		$w.onReady(function () {
			// Redirect to our link
			wixLocation.to("https://campbells.sorted.au/store-finder");
		});

	} else if (re.test(url)){
		// https://www.campbells.com.au/convenience/search?text=coke"
		const myArray = url.split("=");
		let search_term = myArray[1];		

		let url2;

		// If the search term has '+' in it, it must contain two words
		var re2 = new RegExp(/\+/);
		if (re2.test(search_term)){
			const myArray2 = search_term.split("+");
			let search_term1 = myArray2[0];
			let search_term2 = myArray2[1];
	
			url2 = "https://campbells.sorted.au/search/" +search_term1 + "%20" +search_term2;
			console.log(url2);

		} else {
			url2 = "https://campbells.sorted.au/search/" +search_term;
			console.log(url2);
		}

		// Log the original url which got redirected
		console.log("REDIRECT 404 error: " +url);		

		$w.onReady(function () {
			// Redirect to our link
			wixLocation.to(url2);
		});


	} else if (re3.test(url)) {
	// Match on '_890' or '_849'

	// If 404 due to a product, let's just send to ecom site with a prodcode search
	// https://www.campbells.com.au/baby-&-toys/nappy-bags/0000240312_890
	
		const myArray = url.split("/");

		// Get last element in array
		let prodcode_890 = myArray[myArray.length - 1];

		// Split off the _890
		const myArray2 = prodcode_890.split("_");
		let prodcode = myArray2[0];

		// Split off any leading zeros
		const prodcodeWithOutZeros = prodcode.replace(/^0+/g, '');

		let url2 = "https://campbells.sorted.au/search/" +prodcodeWithOutZeros;

		console.log("REDIRECT 404 error: " +url + " To: " +url2);

		$w.onReady(function () {
			// Redirect to our link
			wixLocation.to(url2);
		});


	} else if (goTo !== undefined) {
	// Checks our  Hash of redirect_urls  at top of page and if it matches redirects to its value
		console.log("REDIRECT 404 error: " +url + " To: " +goTo);

		$w.onReady(function () {
			// Redirect to our link
			wixLocation.to(goTo);
		});

	} else {
		// Last resort is to dump them onto the ecom site
		console.log("404 error: " +url);

		$w.onReady(function () {
			
			// Redirect to our link
			wixLocation.to("https://campbells.sorted.au/");
		});
	}


});